import amaresh from "../Images/Experts/1.Amaresh Sarkar.png"
import piyali from "../Images/Experts/2. Piyali Santra.png"
import anamika from "../Images/Experts/3. Anamika Ghosh.png"
import sultan from "../Images/Experts/4. Sultan Mamud.png"
import mehebuba from "../Images/Experts/5. Mehebuba Khatun.png"
import samina from "../Images/Experts/6. Samina Parvin.png"
import nil from "../Images/Experts/7. Nil Kamal Roy.png"

import currentaffair from "../Images/Sub-topics/test1.svg"
import freetest from "../Images/Sub-topics/test2.svg"
import freecourse from "../Images/Sub-topics/globe.svg"
import books from "../Images/Sub-topics/books.svg"
import paidcourse from "../Images/Sub-topics/course.svg"
import paidtest from "../Images/Sub-topics/exam1.svg"
import course from "../Images/Sub-topics/courses.jpg"

export const Key_Features = [
    "Interactive Live Classes","Full HD Live & Recorded Class","Access Quality Study Materials","Learn From Expert Educators","Practice With Mock Tests","Personalized Learning Experience","Study Anytime, Anywhere With Our App"
]

export const experts = [
    {
        img:amaresh,
        name:"Amaresh Sir"
    },{
        img:piyali,
        name:"Piyali Ma'am"
    },{
        img:anamika,
        name:"Anamika Ma'am"
    },{
        img:sultan,
        name:"Sultan Sir"
    },{
        img:mehebuba,
        name:"Mehebuba Ma'am"
    },{
        img:samina,
        name:"Samina Ma'am"
    },{
        img:nil,
        name:"Nil Sir"
    }
]

export const subTopic = [
    {
        src:paidcourse,
        name:"Paid Course"
    },{
        src:books,
        name:"Books"
    },{
        src:paidtest,
        name:"Paid Test"
    },{
        src:freecourse,
        name:"Free Course"
    },{
        src:freetest,
        name:"Free Test"
    },{
        src:currentaffair,
        name:"Current Affairs"
    },{
        src:course,
        url:'/course',
        name:"Courses"
    }
]